import { Box, Typography } from "@mui/material";
import { HeartIcon } from "../../components/icon-components/HeartIcon";
import styles from "./BabySizeText.module.scss";
import { useTranslation } from "react-i18next";

interface BabySizeTextProps {
  title?: string;
  message?: string;
  description?: string;
  align?: "left" | "right" | "center";
  showHereBadge: boolean;
}

const BabySizeText: React.FC<BabySizeTextProps> = ({
  title,
  message,
  description,
  align = "left",
  showHereBadge = true,
}) => {
  const { t } = useTranslation();

  return (
    <Box className={`${styles.wrapper} ${styles[align]}`}>
      {showHereBadge && (
        <Box className={styles.hereBadge}>
          <HeartIcon width={16} height={16} />
          <Typography variant="bodySmall" className={styles.badgeText}>
            {t("babyWeekImages.currentWeekText")}
          </Typography>
        </Box>
      )}
      <Typography variant="subtitle1" fontWeight="bold">
        {title}
      </Typography>
      <Typography variant="body1">{message}</Typography>
      <Typography variant="body2" color="text.secondary">
        {description}
      </Typography>
    </Box>
  );
};

export default BabySizeText;

